import { render, staticRenderFns } from "./AppHeader_Navs_copy.vue?vue&type=template&id=246952e8&scoped=true&"
import script from "./AppHeader_Navs_copy.vue?vue&type=script&lang=js&"
export * from "./AppHeader_Navs_copy.vue?vue&type=script&lang=js&"
import style0 from "./AppHeader_Navs_copy.vue?vue&type=style&index=0&id=246952e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246952e8",
  null
  
)

export default component.exports